import React from 'react';
import { ButtonSecondary } from 'components';
import { useHistory } from 'react-router-dom';
import { useResetRecoilState } from 'recoil';
import { lookupState } from 'state/atoms';

export const ViewDetails = () => {
  const resetLookupState = useResetRecoilState(lookupState);
  const history = useHistory();

  const openCaseDetails = () => {
    resetLookupState();
    history.push('/cases/new/details');
  };

  return (
    <ButtonSecondary onClick={openCaseDetails}>
      View Case Details
    </ButtonSecondary>
  );
};

export default ViewDetails;
